<template>
  <v-snackbar
    v-model="snackbar"
    :bottom="y === 'bottom'"
    :color="color"
    :left="x === 'left'"
    :multi-line="mode === 'multi-line'"
    :right="x === 'right'"
    :timeout="timeout"
    :top="y === 'top'"
    :centered="y === 'centered'"
    :vertical="mode === 'vertical'"
    class="pt-0"
    :content-class="size"
  >
    {{ text }}
    <template #action="{ attrs }">
      <v-btn
        dark
        text
        v-bind="attrs"
        @click="snackbar = false"
        @click.prevent
      >
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>
<script>
export default {
  data: () => ({
    color: '',
    mode: '',
    snackbar: false,
    text: '',
    timeout: 6000,
    x: null,
    y: 'top',
    size: '',
  }),
  mounted() {
    this.$bus.$on('showSuccess', this.showSuccess);
    this.$bus.$on('showError', this.showError);
  },
  methods: {
    showSuccess(text = null, position = null, size = '', timeout = 6000) {
      if (this.snackbar === true) return;
      if (text === '' || text === null) {
        this.text = 'Success';
      } else {
        this.text = text;
      }
      switch(position) {
        case 'centered':
          this.y = 'centered';
          break;
        case 'bottom':
          this.y = 'bottom';
          break;
        default:
          this.y = 'top'
      }
      switch(size) {
        case 'xl':
          this.size = 'xl';
          break;
        default:
          this.size = ''
      }

      this.color = 'green';
      this.snackbar = true;
      this.timeout = timeout;
    },
    showError(text = null, position = null, size = '', timeout = 6000) {
      if (this.snackbar === true) return;
      if (text === '' || text === null) {
        this.text = 'Whoops, something went wrong... Unexpected Error.';
      } else {
        this.text = text;
      }
      switch(position) {
        case 'centered':
          this.y = 'centered';
          break;
        case 'bottom':
          this.y = 'bottom';
          break;
        default:
          this.y = 'top'
      }
      switch(size) {
        case 'xl':
          this.size = 'xl';
          break;
        default:
          this.size = ''
      }

      this.color = 'red';
      this.snackbar = true;
      this.timeout = timeout;
    },
  },
};
</script>
<style scoped>
::v-deep .v-snack__wrapper {
  min-width: 320px !important;
  max-width: 80vw !important;
  width: auto !important;
}

::v-deep .v-snack__content {
  white-space: normal !important;
  height: auto !important;
  min-height: unset !important;
  line-height: 1.3 !important;
  overflow-wrap: anywhere;
  word-break: break-word;
}

::v-deep div.v-snack__content.xl {
  margin: 2rem !important;
  font-size: 2.6rem !important;
  font-weight: bold !important;
  line-height: 1.25 !important;
  white-space: normal !important;
  height: auto !important;
  overflow-wrap: anywhere;
  word-break: break-word;
}

::v-deep .v-snack--centered .v-snack__wrapper {
  max-width: 90vw !important;
}
</style>